import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import PackageCard from "@/components/PackageCard";
import { useApi } from "@/hooks/useApi";
import { useSettings } from "@/context/SettingsContext";

export default function Home() {
  const { data } = useApi("/packages");
  const { settings } = useSettings();
  return (
    <div data-testid="home-page">
      <section className="py-24 bg-slate-50" data-testid="home-programs-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="eyebrow" data-testid="home-eyebrow">{settings?.home_eyebrow}</p>
              <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900" data-testid="home-title">{settings?.home_title}</h1>
            </div>
            <Button asChild size="lg" className="bg-amber-500 text-slate-900 hover:bg-amber-400 font-semibold" data-testid="home-register-button">
              <Link to="/daftar">{settings?.home_button_text || "Daftar Sekarang"} <ArrowRight className="ml-2 h-4 w-4" /></Link>
            </Button>
          </div>
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {(data || []).map((p) => <PackageCard key={p.id} pkg={p} compact />)}
          </div>
        </div>
      </section>
    </div>
  );
}
